import React, { useState, useEffect } from 'react';
import { Alert, Col, Row, Spinner, Table } from 'react-bootstrap';
import '../../../styles/RegDashboard.css';
import { HHIEButton } from '../../utility/HHIEButton';
import { ContentBox } from './utility/ContentBox';
import { ContentItem } from './utility/ContentItem';
import { ContentTitle } from './utility/ContentTitle';

function currentServices(member) {
    var services = "";
    if (member.chr) services += "CHR;";
    if (member.dsm) services += "DSM;";
    if (member.referrals) services += "Referrals;";
    if (member.notify) services += "Notify;";
    if (services.length > 0) {
        services = services.slice(0, -1);
    }
    if (services.length > 0) return services;
    else return <Alert variant='danger'>No services selected</Alert>
}

function noServices(members) {
    var result = false;
    members.forEach(member=>{
        if (!(member.chr || member.dsm || member.referrals || member.notify)) {
            result = true;
        }
    })
    return result;
}

export function MemberSubmissionQueue(props) {
    const [account, setAccount] = useState(null);
    const [members, setMembers] = useState(null);
    const [disableAdd, setDisableAdd] = useState(false);
    const [loading, setLoading] = useState(false);
    const [user, setUser] = useState(props.user)
    const [showServicesAlert, setShowServicesAlert] = useState(false)


    useEffect(() => {
        setAccount(props.account);
        setUser(props.user)
        if (props.Members) {
            let tempMembers = props.Members.filter(member => {
                return FilterSubmittableMember(member)

            })
            if (tempMembers.length === 0) {
                props.hideSubmittableMembers();
            }
            setMembers(tempMembers);
            setDisableAdd(props.disableAdd)
        }
    }, [props]);

    const FilterSubmittableMember = (member) => {
        if (member.processing) {
            return false;
        }
        else if (member.deactivationRequested) {
            return true;
        }
        else {
            if (member.registrationComplete) {
                return false;
            }

            if (member.passStatus.type && member.passStatus.type === "Provider" &&
                (!member.npi || member.npi.length < 10
                    || StringIsEitherNullOrEmpty(member.stateLicense)
                    || StringIsEitherNullOrEmpty(member.specialty)
                    || StringIsEitherNullOrEmpty(member.abbrTitle)
                    || StringIsEitherNullOrEmpty(member.specialty))) {
                return false;
            }

            if (member.passStatus.type && member.passStatus.type.includes("Specialty") &&
                (StringIsEitherNullOrEmpty(member.stateLicense) || StringIsEitherNullOrEmpty(member.jobTitle))) {
                return false;
            }

            if (member.isPOC && StringIsEitherNullOrEmpty(member.pocTypeName)) {
                return false;
            }

            if (StringIsEitherNullOrEmpty(member.firstName)
                || StringIsEitherNullOrEmpty(member.lastName)
                || (!member.hasNoMiddleName && StringIsEitherNullOrEmpty(member.middleName))
                || !member.email || !member.email.includes("@") || !member.email.includes(".")) {
                return false;
            }

            var today = new Date();
            var ten = new Date(today.getFullYear() - 10, 0, 0);
            var onefifty = new Date(today.getFullYear() - 150, 0, 0);
            if (ten < new Date(member.dob) || onefifty > new Date(member.dob)) {
                return false;
            }
        }
        return true;
    }

    const StringIsEitherNullOrEmpty = (value) => {
        var result;
        if (!value || value === "") {
            result = true
        }
        else { result = false }
        return result;
    }


    const submitMembers = () => {
        setLoading(true);
        var memberIds = [];
        for (let member of members) {
            memberIds.push(member.mid)
        }

        const requestOptions = {
            method: "POST",
            body: JSON.stringify(memberIds),
            headers: { "Content-type": "application/json: charset=UTF-8" }
        }
        fetch('api/registration/submitBatchMembers/' + account.id, requestOptions)
            .then((response) => {
                response.json()
                    .then((text) => {
                        if (text.errors !== null && text.errors !== "") alert(text.errors)
                        let finishedMembers = members;
                        for (let finishedMember of finishedMembers) {
                            if (!text.message.includes("The following issues occurred while provisioning " + finishedMember.firstName + " " + finishedMember.lastName)) {
                                finishedMember.processing = true;
                            }
                        }
                        setMembers(finishedMembers);
                        setLoading(false);
                        setDisableAdd(true);
                        props.hideSubmittableMembers();
                        RetrieveAccount(text.message);
                    })
                    .catch((error) => {
                        console.log("batch submit text error: " + error);
                    })
            })
            .catch((error) => {
                console.log("batch submit response error: " + error);
            });
    }

    const overrideSubmitMember = (memberId) => {

        setLoading(true);

        const requestOptions = {
            method: "POST",
            body: JSON.stringify(memberId),
            headers: { "Content-type": "application/json: charset=UTF-8" }
        }
        fetch('api/admin/submitMemberOverride/' + account.id + "/" + user.sfid, requestOptions)
            .then((response) => {
                response.json()
                    .then((text) => {
                        if (text.errors !== null && text.errors !== "") alert(text.errors)
                        let finishedMembers = members;
                        for (let finishedMember of finishedMembers) {
                            if (text.message.includes("Success") && finishedMember.mid === memberId) {
                                finishedMember.processing = true;
                            }
                        }
                        let submittables = finishedMembers.filter(member => FilterSubmittableMember(member));
                        setMembers(submittables);
                        setLoading(false);
                        RetrieveAccount(text.message);
                        if (submittables.length === 0) {
                            props.hideSubmittableMembers()
                        }
                    })
                    .catch((error) => {
                        console.log("batch submit text error: " + error);
                    })
            })
            .catch((error) => {
                console.log("batch submit response error: " + error);
            });
    }

    const RetrieveAccount = (text) => {
        fetch('api/registration/RetrieveAccount/' + account.id)
            .then((acctResponse) => {
                acctResponse.json()
                    .then((acct) => {
                        if (acct.errors !== null && acct.errors !== "") alert(acct.errors)
                        let accts = props.accounts;
                        for (var i = 0; i < accts.length; i++) {
                            if (accts[i].id === acct.message.id) {
                                accts[i] = acct.message;
                            }
                            props.setAccounts(accts);
                        }
                    })
                    .catch((error) => {
                        console.log("Account json error: " + error);
                    })
            })
            .catch((error) => {
                console.log("account response error: " + error);
            });
        alert(text);
    }

    const handleCancelDeactivationRequest = async (member) => {
        const formData = new FormData();
        formData.append("sfid", member.id);
        const requestOptions = {
            method: 'POST',
            body: formData
        }

        const cancelled = await fetch('api/member/undo-deactivation', requestOptions)
            .then(async (response) => {
                try {
                    return await response.json().then(json => {
                        if (json.errors !== null && json.errors !== "") alert(json.errors)
                        return json.message
                    });
                }
                catch (ex) {
                    console.error("undo deactivation error: ", ex);
                    return false;
                }
            })
            .catch(ex => {
                console.error("undo deactivation error: ", ex);
                return false;
            });
        // success
        if (cancelled) {
            // update the DOM remove deactivation request
            var updatedMember = null;
            for (let mem of members) {
                if (mem.id === member.id) {
                    mem.deactivationRequested = false;
                    updatedMember = mem;
                }
            }
            let membersCopy = [...members];
            setMembers(membersCopy);
            let allMembersCopy = [...props.Members];
            for (let m of allMembersCopy) {
                if (updatedMember.id === m.id) {
                    m = updatedMember;
                }
            }
            props.setMembers(allMembersCopy);
            account.Members = membersCopy;
            let accountCopy = { ...account };
            let accts = props.accounts;
            for (var i = 0; i < accts.length; i++) {
                if (accts[i].id === accountCopy.id) {
                    accts[i] = accountCopy;
                }
                props.setAccounts(accts);
            }
        }
        // fail
        else {
            alert("Something went wrong, we couldn't undo your deactivation request for " + member.firstName + " " + member.lastName + ". This request must have reached the HHIE. Please contact them for assistance.");
        }
    };

    const renderMembers = () => {
        let filteredMembers = members

        return filteredMembers.map((member, idx) => {
            var status = (member.id && member.id !== "") ? "Modified" : "New";
            return (
                <tr key={"member" + idx}>
                    <td
                    // style={member.deactivationRequested ? {} : {background: '#ff000061'}}
                    >{member.firstName} {member.middleName} {member.lastName}</td>
                    <td>{currentServices(member)}</td>
                    <td>{(member.registrationComplete ? "Complete" : status)}</td>
                    <td>{member.createdDate.split("T")[0]} </td>
                    <td style={{ textAlign: 'right' }}>
                        {member.deactivationRequested &&
                            <HHIEButton
                                variant="primary"
                                size="sm"
                                onClick={() => { handleCancelDeactivationRequest(member) }}
                                disabled={loading}
                                title="Cancel Deactivation"
                            />
                        }
                        {props.userIsAdmin && !loading &&
                            <HHIEButton
                                variant="warning"
                                size="sm"
                                onClick={() => { overrideSubmitMember(member.mid) }}
                                disabled={loading}
                                title={loading ? <Spinner animation="border" /> : "Override Submit"}
                            />}
                    </td>
                </tr>
            )
        })
    }

    return (
        <>
            {props.showSubmittableMembers &&
                <ContentBox>
                    <Row>
                        <ContentTitle
                            position="left"
                            title="Member Submission Queue"
                        />
                    </Row>
                    {!showServicesAlert &&
                        <Row>
                            <Col></Col>
                            <ContentItem
                                position="most-right"
                                content={
                                    <HHIEButton
                                        id="batch-submit"
                                        variant="primary"
                                        size="sm"
                                        disabled={disableAdd || loading}
                                        onClick={() => { if (noServices(members)) setShowServicesAlert(true); else submitMembers() }}
                                        title={loading ? <Spinner animation="border" /> : "Submit members to the HHIE"}
                                    />
                                }
                            />
                        </Row>
                    }
                    {
                        showServicesAlert &&

                        <Alert variant='danger'>
                            <div>Some members have no services. Submit anyway?</div>
                            <ContentItem
                                position="most-right"
                                content={
                                    <>
                                        <HHIEButton
                                            id="batch-submit"
                                            variant="primary"
                                            size="sm"
                                            disabled={disableAdd || loading}
                                            onClick={() => { submitMembers(); setShowServicesAlert(false) }}
                                            title={loading ? <Spinner animation="border" /> : "Submit members to the HHIE"}
                                            marginl={4}
                                        />
                                        <HHIEButton
                                            id="batch-submit"
                                            variant="danger"
                                            size="sm"
                                            disabled={disableAdd || loading}
                                            onClick={() => { setShowServicesAlert(false) }}
                                            title={loading ? <Spinner animation="border" /> : "Cancel"}
                                            marginl={4}
                                        />
                                    </>
                                }
                            />
                        </Alert>

                    }
                    <Table
                        id="submit-members-table"
                        className="members-table"
                        striped
                        bordered
                        hover
                        responsive="sm"
                        variant="light"
                    >
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Services</th>
                                <th>Status</th>
                                <th>Created Date</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {members && renderMembers()}
                        </tbody>
                    </Table>
                </ContentBox>
            }
        </>
    );
}
